import { gql } from "@apollo/client";

export const GET_AVAILABLE_INTEGRATIONS = gql`
  query GetAvailableIntegrations {
    getAvailableIntegrations {
      message
      list {
        key
        label
        category
        logo_path
        idp_eligible
        domains {
          id
          title
          key
        }
      }
    }
  }
`;

export const GET_ALL_AVAILABLE_INTEGRATIONS = gql`
  query GetAllAvailableIntegrations {
    getAllAvailableIntegrations {
      message
      list {
        key
        label
        category
        logo_path
        domains {
          id
          title
          key
        }
      }
    }
  }
`;

export const GENERATE_TRUTO_LINK_TOKEN = gql`
  mutation generateTrutoLinkToken {
    generateTrutoLinkToken {
      message
      linkToken
    }
  }
`;

export const GET_CUSTOMER_INTEGRATIONS = gql`
  query getCustomerIntegrations {
    getAccountDetails {
      userDetails {
        user_type
        employee_data_id
        roles {
          role_id
          role_name
          role_description
        }
      }
      userIntegrationsDetails {
        list {
          id
          integration_resource_id
          is_active
          integration_label
          integration_key
          category
          updated_at
          inactivity_reason
          account_label
          account_email
          integration_id
          use_as_idp
          idp_priority
          regions
        }
      }
    }
  }
`;

export const GET_SYSTEM_OWNER_INTEGRATION_MAPPING = gql`
  query GetSystemOwnerAndIntegrationMapping {
    getSystemOwnerAndIntegrationMapping {
      success
      message
      data {
        id
        system_owner
        integrated_resource_id
        integration_type
        integration_label
        account_label
        logo_path
        category
        employee_email
        employee_name
      }
    }
  }
`;

export const CREATE_SYSTEM_OWNER_INTEGRATION = gql`
  mutation CreateSystemOwnerOfAIntegrations(
    $integrationResourceId: String!
    $employeeDataIds: [String!]!
  ) {
    createSystemOwnerOfAIntegrations(
      integrationResourceId: $integrationResourceId
      employeeDataIds: $employeeDataIds
    ) {
      success
      message
    }
  }
`;

export const DELETE_INTEGRATION_OWNER_MAPPINGS = gql`
  mutation DeleteIntegrationOwnerMappings(
    $integrationResourceId: String!
    $employeeDataIds: [String!]!
  ) {
    deleteIntegrationOwnerMappings(
      integrationResourceId: $integrationResourceId
      employeeDataIds: $employeeDataIds
    ) {
      success
      message
    }
  }
`;

export const STORE_INTEGRATION_RESOURCE_DETAILS = gql`
  mutation storeIntegrationResourceId(
    $integratedAccountId: String!
    $integrationKey: String!
    $sync: Boolean!
    $integrationType: String!
    $regions: [String]
  ) {
    storeIntegrationResourceId(
      integrationKey: $integrationKey
      integrationResourceId: $integratedAccountId
      integrationType: $integrationType
      sync: $sync
      regions: $regions
    ) {
      success
      message
    }
  }
`;

export const UPDATE_INTEGRATION_REGIONS = gql`
  mutation updateIntegrationRegions($id: String!, $regions: [String]) {
    updateIntegrationRegions(id: $id, regions: $regions) {
      success
      message
    }
  }
`;

export const DELETE_INTEGRATION = gql`
  mutation deleteIntegrationById($id: String!) {
    deleteIntegrationById(id: $id) {
      success
      message
    }
  }
`;

export const SET_INTEGRATION_USE_AS_IDP = gql`
  mutation setIntegrationUseAsIdp($rciId: String!, $useAsIdp: Boolean!) {
    setIntegrationUseAsIdp(rciId: $rciId, useAsIdp: $useAsIdp) {
      success
      message
    }
  }
`;

export const SET_IDP_PRIORITY_ORDER = gql`
  mutation setIdpPriorityOrder($rciIds: [String!]!) {
    setIdpPriorityOrder(rciIds: $rciIds) {
      success
      message
    }
  }
`;

export const GENERATE_TRUTO_REAUTH_TOKEN = gql`
  mutation generateTrutoReauthToken($rciId: String!) {
    generateTrutoReauthToken(rciId: $rciId) {
      success
      message
      linkToken
    }
  }
`;

// Connected integrations only, for the Trust Center subprocessor list.
export const GET_CONNECTED_INTEGRATIONS = gql`
  query getConnectedIntegrations {
    getAccountDetails {
      userIntegrationsDetails {
        list {
          id
          is_active
          integration_label
          integration_key
          category
        }
      }
    }
  }
`;
